import React from "react";

export default function IndexPage() {
  return (
    <>
      <h1>Permaconn Accounting</h1>
      <p>
        New accounting and billing system is added to increase transparency,
        re-usability and robustness of billing and other accounting processes.
      </p>
      <p>
        All accounting stored data and processes will be exposed through this
        service. This will allow detection and correction of potential errors
        and re-attempting actions when they fail.
      </p>
      <p>
        This will also work as a cache of all related myob data to speed things
        up.
      </p>
    </>
  );
}
